<template>
<div class="auther_table_wrap">
  <el-table
      :data="words"
      border
      style="width:95.2%;margin:0px auto;" size="medium" >
      <el-table-column
        prop="id"
        label="序号"
        width="60">
      </el-table-column>
      <el-table-column
        prop="word"
        label="敏感词汇">
      </el-table-column>
      <el-table-column
        prop="weights"
        label="权重">
      </el-table-column>
      <el-table-column
        prop="hold_count"
        label="拦截次数">
      </el-table-column>
      <el-table-column
      label="操作"
      width="160">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="fnPopShow(scope.row.id)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="fnDelChannel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
   </el-table>

    <el-dialog title="修改词汇" :visible.sync="pop_show" append-to-body>
        <el-form :model="WordsForm" status-icon :rules="rulesWordsForm" ref="WordsForm" label-width="100px">
          <el-form-item label="敏感词：" prop="word">
            <el-input type="text" v-model="WordsForm.word" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="权重：" prop="weights">
            <el-input type="text" v-model="WordsForm.weights" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('WordsForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>

</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'OptionsTable',
  props:['words'],
   data () {
    return {
      pop_show:false,
      group_type_list:[],
      category_list:[],
      WordsForm:{
        word:'',
        weights:''
      },
      rulesWordsForm:{
      }
    }
  },
  methods:{
  	fnPopShow(id){
  		this.pop_show = true;
      this.edit_id = id;
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/sensitive_words/'+this.edit_id, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json',
        })
        .then(dat=>{
            console.log(dat);
            this.WordsForm = dat.data.data;

        }).catch(err=>{
           console.log(err.response);
      });
  	},
  	submitForm(){
      let token = localStorage.token;
  		this.axios.put(cons.apis + '/v1_0/sensitive_words/'+this.edit_id, {
             "word": this.WordsForm.word,
              "weights": this.WordsForm.weights
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        }).then(dat=>{
          this.$message({
            type: 'success',
            message: '频道修改成功!'
          });
        	this.pop_show = false;
          this.resetForm('WordsForm');
          this.$emit('fnResetTable');
        }).catch(err=>{
        	console.log(err.response);
        })
  	},
  	fnDelChannel(id){
        this.edit_id = id;
        let token = localStorage.token;
        this.$confirm('此操作将删除该词汇, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.delete(cons.apis + '/v1_0/sensitive_words/'+this.edit_id,{
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '删除词汇成功!'
            });
            this.$emit('fnResetTable');
          }).catch(err=>{
            if(err.response.status==404){
               this.$message({
                  type:'info',
                  message:'频道未找到！'
                });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
  	},
    resetForm(formName){
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scope>
.el-table th,.el-table td{
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/SensitiveSetTable.vue